import React, { useState } from 'react';
import { Table, Dropdown, Menu, Button, Space, Typography } from 'antd';
import { EyeOutlined, DeleteOutlined, DownOutlined } from '@ant-design/icons';
import './ViewAllProvider.css';

const { Title } = Typography;

const ViewAllProvider = () => {
  // Sample data for categories
  const dataSource = [
    { key: '1', name: 'RV Parking', totalServices: '10' },
    { key: '2', name: 'Mental Wellness', totalServices: '15' },
    { key: '3', name: 'Education', totalServices: '8' },
  ];

  // Define columns
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Total Services', dataIndex: 'totalServices', key: 'totalServices' },
    { 
      title: 'Action', 
      key: 'action', 
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <Button icon={<DownOutlined />} size="small">
              Actions
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];

  // Menu for dropdown actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="2" icon={<DeleteOutlined />} onClick={() => handleDelete(record)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  // Placeholder functions for actions
  const handleView = (record) => {
    console.log('View:', record);
  };

  const handleDelete = (record) => {
    console.log('Delete:', record);
  };

  return (
    <div className="view-all-provider-container">
      <Title level={3} className="view-all-provider-title">All Categories</Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 5 }}
        className="view-all-provider-table"
        scroll={{ x: true }} // Allow horizontal scrolling if needed
      />
    </div>
  );
};

export default ViewAllProvider;